import {Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import {ChangeLog} from './change_log/ChangeLog.jsx';
import {BrickContext} from 'olympe';
import CloseIcon from '@mui/icons-material/Close';

/**
 * This component display a simple popup with an error message
 * @param {ChangeLogPopup.propTypes} props
 * @return {JSX.Element}
 */
export function ChangeLogPopup(props) {
    return (
        <Dialog
            maxWidth={'xl'}
            fullWidth={true}
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="change-log"
        >
            <div>
                <div className='pr-popup-header'>
                    <DialogTitle id="popup-title">Change log</DialogTitle>
                    <IconButton
                        data-cy={'change-log-close-btn'}
                        aria-label="close"
                        onClick={props.onClose}>
                        <CloseIcon
                            sx={{
                                width: '36px',
                                height: '36px',
                            }}
                        />
                    </IconButton>
                </div>
                <DialogContent>
                    <ChangeLog prTag={props.prTag} context={props.context}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
}

ChangeLogPopup.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    prTag: PropTypes.string,
};
